export default (() => {
  $('.main-menu__parent-trigger').on('click', function (evt) {
    evt.preventDefault();

    let this_button = $(this);
    let next_ul = $(this).next('ul');

    if (this_button.hasClass("is-disabled")) {
      this_button.removeClass('is-disabled').addClass('is-active');
      next_ul.addClass('is-active');
    } else {
      this_button.removeClass('is-active').addClass('is-disabled');
      next_ul.removeClass('is-active');
    }
  });
})



// WEBPACK FOOTER //
// ./themes/app/assets/js/modules/mainMenu.js